export const appConfig = {
  REFRESH_INTERVAL_MS: 15000,
};
